function storageFor(type) {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return type === "session"
      ? window.sessionStorage
      : window.localStorage;
  } catch {
    return null;
  }
}

function safeGet(type, key) {
  try {
    return storageFor(type)?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

function safeSet(type, key, value) {
  try {
    storageFor(type)?.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

function safeRemove(type, key) {
  try {
    storageFor(type)?.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export const safeLocalStorage = {
  getItem(key) {
    return safeGet("local", key);
  },

  setItem(key, value) {
    return safeSet("local", key, value);
  },

  removeItem(key) {
    return safeRemove("local", key);
  },
};

export const safeSessionStorage = {
  getItem(key) {
    return safeGet("session", key);
  },

  setItem(key, value) {
    return safeSet("session", key, value);
  },

  removeItem(key) {
    return safeRemove("session", key);
  },
};
